import { render, staticRenderFns } from "./nasabah.vue?vue&type=template&id=026233f7&"
import script from "./nasabah.vue?vue&type=script&lang=js&"
export * from "./nasabah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports